// layout.divider.v1 — thin horizontal/vertical rule.
//
// Use sparingly; prefer Section gaps for breathing room and Cards for
// strong separation. Dividers are for cases where two pieces of content
// must visually group but need a clear seam (e.g. a toolbar above a
// scroll area).

import { splitProps } from "solid-js"

export interface DividerProps {
  orientation?: "horizontal" | "vertical"
  weight?: "weak" | "default"
  class?: string
}

export function Divider(props: DividerProps) {
  const [local, rest] = splitProps(props, ["orientation", "weight", "class"])

  return (
    <div
      data-component="layout.divider"
      data-orientation={local.orientation ?? "horizontal"}
      data-weight={local.weight ?? "default"}
      role="separator"
      classList={{
        "shrink-0": true,
        "h-px w-full": (local.orientation ?? "horizontal") === "horizontal",
        "w-px h-full": local.orientation === "vertical",
        "bg-border-weaker-base": (local.weight ?? "default") === "weak",
        "bg-border-weak-base": local.weight === "default",
        [local.class ?? ""]: !!local.class,
      }}
      {...rest}
    />
  )
}
